import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { UserRound, Building2, ArrowRight } from 'lucide-react';
import TopBar from '../../components/TopBar';
import PesoLayout from './PesoLayout';
import { useOffice } from './officeCtxRef';

/**
 * PESO office landing — simplified 2026-07-10 (user request): standard Bohol Trabaho
 * top menu + the official blue PESO/LGU banner + the two registration cards + footer.
 * The pilot badge, "Modernized PESO Employment System" hero, and the benefits table
 * were removed to keep the page focused on the two register actions.
 */
const PanglaoPesoLanding = ({ profile, setProfile }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const office = useOffice();
  const slug = office?.slug || 'panglao';
  const officeName = office?.office?.name || 'PESO Panglao';

  return (
    <>
      <TopBar profile={profile} setProfile={setProfile} />
      <PesoLayout>
        <Helmet><title>{`${officeName} Registration | Bohol Trabaho`}</title></Helmet>

        {/* Two registration paths */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
          <button
            onClick={() => navigate(`/peso/${slug}/seeker`)}
            className="group rounded-2xl border-2 border-blue-200 bg-white p-6 text-left shadow-sm hover:border-blue-500 hover:shadow-md transition"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-600 text-white mb-4">
              <UserRound size={26} />
            </div>
            <h2 className="text-lg font-bold text-slate-900">{t('peso.seekerCardTitle', 'Register as a Job Seeker')}</h2>
            <p className="mt-1 text-sm text-slate-500">{t('peso.seekerCardBody', 'Digital NSRP registration. Take a photo of your resume and we fill in your form automatically.')}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-blue-700 group-hover:gap-2 transition-all">
              {t('peso.seekerCardCta', 'Start NSRP registration')} <ArrowRight size={16} />
            </span>
          </button>

          <button
            onClick={() => navigate(`/peso/${slug}/employer`)}
            className="group rounded-2xl border-2 border-blue-200 bg-white p-6 text-left shadow-sm hover:border-blue-500 hover:shadow-md transition"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-800 text-white mb-4">
              <Building2 size={26} />
            </div>
            <h2 className="text-lg font-bold text-slate-900">{t('peso.employerCardTitle', 'Employer: Register & Post a Vacancy')}</h2>
            <p className="mt-1 text-sm text-slate-500">{t('peso.employerCardBody', 'Create your employer account and submit your first job vacancy to reach qualified jobseekers.')}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-blue-700 group-hover:gap-2 transition-all">
              {t('peso.employerCardCta', 'Register & post a job')} <ArrowRight size={16} />
            </span>
          </button>
        </div>
      </PesoLayout>
    </>
  );
};

export default PanglaoPesoLanding;
